// Een projectperceel heeft een id; een kavel buiten het project alleen zijn
// kadastrale naam — daarvan kent de chat alleen de openbare kaartgegevens.
export type ActiveParcel = { id?: number; name: string };

export const activeParcelFor = (
  cubeName: string | undefined,
  parcels: { id: number; name: string }[] | undefined
): ActiveParcel | undefined => {
  if (!cubeName) return undefined;
  const parcel = parcels?.find((item) => item.name === cubeName);
  return parcel ? { id: parcel.id, name: parcel.name } : { name: cubeName };
};

export const chipLabel = (active: ActiveParcel): string =>
  active.id === undefined ? `${active.name} (niet in project)` : active.name;

// Weggeklikt geldt voor deze selectie; het paneel wist `dismissed` zodra er een
// ander kavel wordt aangeklikt, zodat de chip dan terugkomt.
export const chipParcel = (
  match: ActiveParcel | undefined,
  dismissed: string | undefined
): ActiveParcel | undefined => (match && match.name !== dismissed ? match : undefined);

// Wat er met de vraag meegaat: het id van een projectperceel, of de naam van een
// kavel daarbuiten. De server controleert beide.
export const activeParcelBody = (active: ActiveParcel | undefined) =>
  active === undefined
    ? {}
    : active.id !== undefined
      ? { active_parcel_id: active.id }
      : { active_kavel: active.name };
